import * as React from 'react';
import { ReactNode } from 'react';
import { Tag } from 'primereact/tag';

export const parseScope = (scope: string, onClick: (string) => void): ReactNode => {
  let key: string;
  switch (scope) {
    case '/person/update':
      key = 'person_update';
      break;
    case '/read-limited':
      key = 'read_limited';
      break;
    case '/activities/update':
      key = 'activities_update';
      break;
    default:
      return <Tag className={'m-1'} value={scope}></Tag>;
  }
  return <Tag key={key} style={{cursor: 'pointer'}} className={'m-1'} value={key}
              onClick={(): void => onClick(key)}></Tag>;

};
